














































































































































































































































import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

// utils hhelpers
import mixins from '@/utils/mixins';

// mixins
import componentState from '@/mixins/state';
import { QuoteProductItem, QuoteProductCategory, Quote } from '@/models/quote';
import { Module } from '@/models/configurator/module';
import {
  Configuration,
  ConfigurationItem,
  IConfigurationItemData
} from '@/models/configurator/configuration';
import { cloneDeep, head } from 'lodash';
import { IQuoteProductItem } from '@/models';

import ModuleArchivedBanner from '../configurator/modules/ModuleArchivedBanner.vue';

enum DiscountType {
  GLOBAL,
  PER_ITEM
}

export default mixins(componentState).extend({
  name: 'QuoteProductCustomDiscountsDialog',

  components: { ModuleArchivedBanner },

  props: {
    quote: { type: Quote },
    onlyUnitCost: { type: Boolean }
  },

  data: () => ({
    showDialog: false,
    exchangeRate: 1,
    currencyCode: 'USD',
    snapshot: undefined as number | undefined,

    currentModule: null as null | Module,
    configuration: null as null | Configuration,
    productItems: [] as IQuoteProductItem[],

    configurationItemsLoading: false,
    configurationItems: [] as ConfigurationItem[],
    selectedProductItem: null as number | null,
    selectedProduct: null as IQuoteProductItem | null,

    // type
    type: DiscountType.GLOBAL,
    DiscountType,

    quoteProductCategory: (null as unknown) as QuoteProductCategory,
    originalGlobalDiscountPercentage: undefined as number | undefined,
    applyGlobalDiscountPercentageLoading: false,

    isDiscountValid: true
  }),

  computed: {
    percentRules(): ((v: number) => boolean | string)[] {
      return [
        (v: number) => v <= 100 || 'Cannot be greater than 100%',
        (v: number) => v >= 0 || 'Cannot be less than 0%'
      ];
    },

    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),

    quoteIdFromUrlOrProp(): number {
      return Number(this.$route.params.quoteId ?? this.quote.number);
    },

    quoteRevisionFromUrlOrProp(): number {
      return Number(this.$route.params.quoteRevision ?? this.quote.revision);
    },

    subTotal(): number {
      return (
        this.productItems.reduce(
          (acc, cur) => acc + cur.price! * cur.quantity!,
          0
        ) || 0
      );
    },

    configurationItemsForProduct(): ConfigurationItem[] {
      return this.configurationItems.filter(item => {
        return item.configuration == this.selectedProduct?.configuration;
      });
    },

    totalDiscountAmount(): number {
      return this.configurationItems
        .map(config => Number(config.discount!))
        .reduce((total, amount) => total + amount, 0);
    },

    totalPriceAmount(): number {
      return this.configurationItems
        .map(config => Number(config.price))
        .reduce((total, amount) => total + amount, 0);
    }
  },

  methods: {
    ...mapActions({
      fetchConfiguration: 'configuratorConfiguration/fetchConfiguration',
      applyGlobalDiscountPercentage: 'quote/applyGlobalDiscountPercentage',
      fetchQuoteConfigurationItems: 'quote/fetchQuoteConfigurationItems'
    }),

    ...mapActions('configuratorModule', [
      'createModule',
      'fetchModule',
      'fetchModules',
      'updateModule'
    ]),

    closeDialog(data: any) {
      this.productItems = [];
      this.configurationItems = [];
      this.currentModule = null;
      this.selectedProductItem = null;
      this.selectedProduct = null;
      this.configurationItemsLoading = false;

      this.showDialog = false;
    },

    fetchQuoteCategoryItems(quoteProductCategory: QuoteProductCategory) {
      return this.fetchQuoteConfigurationItems({
        id: this.quoteIdFromUrlOrProp,
        revision: this.quoteRevisionFromUrlOrProp,
        quoteProductCategory: quoteProductCategory.id
      }).then((items: IConfigurationItemData[]) => {
        const configurationItems = items.map(
          item => new ConfigurationItem(item)
        );
        this.configurationItems = configurationItems;
      });
    },

    open(
      quoteProductCategory: QuoteProductCategory,
      exchangeRate: number,
      currencyCode: string,
      snapshot?: number
    ) {
      this.exchangeRate = exchangeRate;
      this.currencyCode = currencyCode;
      this.snapshot = snapshot;
      this.quoteProductCategory = quoteProductCategory;
      this.setOriginalGlobalDiscountPercentage(quoteProductCategory);
      this.getModule(quoteProductCategory.module!);
      this.productItems = quoteProductCategory.products ?? [];

      if (this.productItems.length) {
        this.selectedProduct = head(this.productItems)!;

        if (this.selectedProduct) {
          this.selectedProductItem = this.productItems.indexOf(
            this.selectedProduct
          );
        }
      }

      this.fetchQuoteCategoryItems(quoteProductCategory).then(() => {
        // await products to lead first then show dialog
        this.showDialog = true;
      });
    },

    async getModule(module: number | string) {
      try {
        if (this.currentModule) {
          this.currentModule = this.getModuleById(Number(module));
        } else {
          this.currentModule = await this.fetchModule(module);
        }
      } catch (err) {
        this.setComponentState('error', err);
      }
      return this.currentModule;
    },

    applyGlobalDiscounts() {
      this.applyGlobalDiscountPercentageLoading = true;

      this.applyGlobalDiscountPercentage({
        id: this.quoteIdFromUrlOrProp,
        revision: this.quoteRevisionFromUrlOrProp,
        category: this.quoteProductCategory.id,
        global_discount_percentage: this.quoteProductCategory
          .global_discount_percentage,
        accessory_discount_percentage: this.quoteProductCategory
          .accessory_discount_percentage,
        configuration: this.selectedProduct?.configuration
      })
        .then(() => {
          this.refreshConfigurationItems().then(() => {
            this.$emit('update:discount', this.totalDiscountAmount);
            this.$emit('update:price', this.totalPriceAmount);
          });
          // set this local global percentage as the new fixed value to compare against
          this.setOriginalGlobalDiscountPercentage(this.quoteProductCategory);
        })
        .finally(() => {
          this.applyGlobalDiscountPercentageLoading = false;
        });
    },

    applyItemPriceModification() {
      this.refreshConfigurationItems().finally(() => {
        this.$emit('update:discount', this.totalDiscountAmount);
        this.$emit('update:price', this.totalPriceAmount);
      });
    },

    setOriginalGlobalDiscountPercentage(
      quoteProductCategory: QuoteProductCategory
    ) {
      this.originalGlobalDiscountPercentage = cloneDeep(
        Object.freeze(quoteProductCategory.global_discount_percentage)
      );
    },

    async loadConfigurableItems(
      item: QuoteProductItem,
      active?: boolean,
      toggle?: () => void
    ) {
      if (active) {
        if (toggle) toggle();
      } else {
        if (toggle) toggle();
        this.selectedProduct = item;
      }
    },

    refreshConfigurationItems() {
      return this.fetchQuoteCategoryItems(this.quoteProductCategory);
    }
  }
});
